import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InspectionPlanSelectorComponent } from './inspection-plan-selector.component';

@NgModule({
  declarations: [
    InspectionPlanSelectorComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InspectionPlanSelectorComponent
  ]
})
export class InspectionPlanSelectorModule { } 